import { useParams } from "react-router-dom";
import FormOverview from "./FormOverview";
import FormSettings from "./FormSettings";
import { isValidFormId } from "./formUtils";

export default function FormIndexRoute() {
  const { id } = useParams();
  if (id === "new" || !isValidFormId(id)) {
    return <FormSettings />;
  }
  return <FormOverview />;
}
